import { Brand } from '@app/features/scope-overview/model/brand.model'
import { OfficeLocation } from './office-location'
import { SecondParty } from '@core/model/second-party.model'
import { SecondPartyContact } from '@app/features/scope-overview/model/second-party-contact.model'
import { Type } from 'class-transformer'

export class FolderIdentity {
  id!: number
  localId!: number
  archived!: boolean
  isTemplate!: boolean
  @Type(() => SecondParty) secondParty!: SecondParty
  @Type(() => SecondPartyContact) secondPartyContact!: SecondPartyContact
  @Type(() => OfficeLocation) location!: OfficeLocation
  @Type(() => OfficeLocation) officeLocation!: OfficeLocation
  @Type(() => Brand) brand!: Brand
  xlsxTemplate?: any
}
